import router from './router'

// 白名单
//const white = ['/login', '/autoLogin'];

//全局前置守卫 
router.beforeEach(async (to, from, next) => {
  console.log('[当前页面路径] ' + to.path);
  // set page title

  next();


})